import React from "react";
import { ExlyInput } from "common/form";
import { StateSelect } from "./StateSelect";
import {
  INTERNATIONAL_PAYMENT_FIELDS,
  INTERNATIONAL_PAYMENT_FIELDS_CONFIG,
} from "./InternationalPayment.constants";

export const InternationalPaymentFields = ({
  formValues,
  formMeta,
  onChange,
  onBlur,
}) => (
  <div className="tw-flex tw-flex-col tw-gap-3 tw-my-5">
    {INTERNATIONAL_PAYMENT_FIELDS.map(
      ({ name, label, placeholder, required, isSelect }) => {
        const meta = formMeta?.[name] ?? { touched: false, error: "" };

        if (isSelect) {
          return (
            <div key={name}>
              <div className="tw-mb-1">
                <span className="tw-text-md tw-text-black tw-font-semibold">
                  {label}
                </span>
                {required && (
                  <span className="tw-text-red-500 tw-ml-0.5">*</span>
                )}
              </div>
              <StateSelect
                value={formValues[name]}
                onChange={(val) => onChange(val, name)}
                onBlur={() => onBlur?.(name)}
                meta={meta}
                placeholder={placeholder}
              />
            </div>
          );
        }

        return (
          <ExlyInput
            key={name}
            fieldLabel={{ text: label, required }}
            placeholder={placeholder}
            input={{
              value: formValues[name] ?? "",
              name,
              onChange: (e) => onChange(e.target.value, name),
              onBlur: () => onBlur?.(name),
            }}
            meta={meta}
            fullWidth
          />
        );
      }
    )}
  </div>
);

export { INTERNATIONAL_PAYMENT_FIELDS_CONFIG };
